import {Divider, Row, Col, Space, Table} from "antd";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import http from "../../http";
import UserMachineListPage from "./UserMachineListPage";
import {useTranslation} from "react-i18next";
import DataTable from "../../components/DataTable/DataTable";

const UserDetailPage=(props)=>{
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const [loading, setLoading] = useState(false);
    const [isValidState, setValidState] = useState(!!state?.user);
    // const [assignmentDataSource, setAssignmentDataSource] = useState([]);
    const { t } = useTranslation();
    const columns = [
        {
            title: t('lease_historylist_col1'),
            dataIndex: 'contract_code',
            key: 'contract_code',
        },
        {
            title: t('lease_historylist_col9'),
            dataIndex: 'reference_code',
            key: 'reference_code',
        },
        {
            title: t('lease_historylist_col2'),
            dataIndex: 'active_history',
            key: 'startDate',
            render: (text)=>(
                <div>{text.start_date}</div>
            )
        },
        {
            title: t('lease_historylist_col3'),
            dataIndex: 'active_history',
            key: 'endDate',
            render: (text)=>(
                <div>{text.end_date}</div>
            )
        },

        {
            title: t('lease_historylist_col4'),
            dataIndex: 'machine_name',
            key: 'machineName',
        },
        {
            title: t('lease_historylist_col5'),
            dataIndex: 'machine_data',
            key: 'machineId',
            render: (text)=>(
                <div>{text.identifier}</div>
            )
        },
        {
            title: t('lease_historylist_col6'),
            dataIndex: 'status_text',
            render: (text)=>(
                <div>{t(text)}</div>
            ),
            key: 'statusText',
        },
        {
            title: t('lease_historylist_col7'),
            dataIndex: 'constructor_data',
            key: 'leaseTo',
            render: (text) => (
                <div>{(text.company_name)}</div>
            ),
        },
    ]
    // const fetchDefaultData =()=>{
    //     setLoading(true);
    //     http.get(`/api/v1/machines/constructor_machines/?machine__assigned=${state.user.id}`).then((resp)=>{
    //         setAssignmentDataSource(resp.data.results);
    //         setLoading(false);
    //     }).catch(()=>{
    //         setLoading(false);
    //     })
    // }

    useEffect(()=>{
        if(!state){
            navigate('/content_not_found',{replace: true})
        }
        // fetchDefaultData()
    }, [state])

    const buildBreadcrumbs=()=>{
        let breadcrumbs = [];
        if(state.breadcrumbs){
            state.breadcrumbs.map((item, index)=>{
                breadcrumbs.push(
                    <><Link to={item.to} state={item.state} key={index}>{item.title}</Link> > </>
                )
            })
            breadcrumbs.push(<>{state.user.full_name}</>)
            return breadcrumbs;
        }
        return <><Link to={'/users'}>{t('staff_listpage_title')}  </Link> >  {state.user.full_name}</>;
    }
    if(isValidState) {
        return (
            <>
                <div style={{overflowY: 'auto', overflowX: 'hidden', width: '100%', height: '100%'}}>
                    <Row style={{height: '5%', color: "black", fontWeight: 'bold', justifyContent: 'space-between'}}>
                        <Col>
                            <Space>{buildBreadcrumbs()}</Space>
                        </Col>
                    </Row>
                    <Row style={{display: 'flex', flexDirection: 'column'}}>
                        <Col style={{lineHeight: '1.5rem'}}><h1>{state.user.full_name}</h1></Col>
                        <Col>{t('staff_username_field')} : {state.user.username}</Col>
                        <Col>{t('staff_email_field')} : {state.user.email}</Col>
                        <Col>{t('staff_mobile_field')} : {state.user.mobile}</Col>
                        <Col>{t('staff_slackid_field')} : {''}</Col>
                    </Row>
                    <Divider/>
                    <Row style={{overflow: "hidden", height: '60%'}}>
                        <div style={{width: '100%', height: '100%'}}>
                            <UserMachineListPage pageSize={3} user={state.user}/>
                        </div>
                    </Row>
                    <Divider style={{marginTop: '10px'}}/>
                    <Row style={{display: 'flex', flexDirection: 'column'}}>
                        <Col>
                            <p style={{fontWeight: "bold", fontSize: "800"}}> {t('lease_historylist_title')} </p>
                        </Col>
                        <Col>
                            <DataTable
                                locale={{emptyText: t('table_no_data_text')}}
                                sticky={true}
                                loading={loading}
                                url={`/api/v1/machines/constructor_machines/?machine__assigned=${state.user.id}`}
                                columns={columns}
                                pagination={true}
                            />
                        </Col>
                    </Row>
                </div>
            </>

        )
    }
    else{
        return null;
    }
}

export default UserDetailPage;
